import React, { useEffect, useState } from 'react';
import { Plus, X, Edit2, Trash2, Star, CheckCircle } from 'lucide-react';
import api from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import { puoFare } from '../../utils/permessi';

const empty = { nome:'', importo:'', descrizione:'', divisibile:false };

export default function ListinoAttivita() {
  const { user } = useAuth();
  const puoCreare     = puoFare(user, 'dipendenti', 'create');
  const puoModificare = puoFare(user, 'dipendenti', 'edit');
  const puoEliminare  = puoFare(user, 'dipendenti', 'delete');
  const [voci, setVoci]       = useState([]);
  const [showPanel, setShowPanel] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm]       = useState(empty);
  const [saving, setSaving]   = useState(false);

  const load = () => api.get('/dipendenti/listino').then(r => setVoci(r.data));
  useEffect(() => { load(); }, []);

  const openNew  = () => { setEditing(null); setForm(empty); setShowPanel(true); };
  const openEdit = (v) => { setEditing(v); setForm({ nome:v.nome, importo:String(v.importo), descrizione:v.descrizione||'', divisibile:v.divisibile, attivo:v.attivo }); setShowPanel(true); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editing) await api.put(`/dipendenti/listino/${editing.id}`, form);
      else         await api.post('/dipendenti/listino', form);
      setShowPanel(false); setEditing(null); setForm(empty); load();
    } catch(e) { alert(e.response?.data?.error || 'Errore'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (v) => {
    if (!window.confirm(`Disattivare "${v.nome}"?`)) return;
    try { await api.delete(`/dipendenti/listino/${v.id}`); load(); }
    catch(e) { alert(e.response?.data?.error || 'Errore'); }
  };

  const handleToggle = async (v) => {
    try { await api.put(`/dipendenti/listino/${v.id}`, { ...v, attivo: !v.attivo }); load(); }
    catch(e) { alert(e.response?.data?.error || 'Errore'); }
  };

  const attive    = voci.filter(v => v.attivo);
  const disattive = voci.filter(v => !v.attivo);

  return (
    <div style={{ display:'flex', gap:'20px' }}>
      <div style={{ flex:1 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'20px' }}>
          <div>
            <h1 style={s.title}>LISTINO ATTIVITÀ</h1>
            <p style={{ color:'var(--text-dim,#666)', fontSize: 'var(--font-size-xs)', marginTop:'4px' }}>
              Compensi fissi per attività extra (tornei, eventi)
            </p>
          </div>
          {puoCreare && <button style={s.btnPri} onClick={openNew}><Plus size={15}/> NUOVA VOCE</button>}
        </div>

        {/* Voci attive */}
        <div style={{ display:'flex', flexDirection:'column', gap:'8px', marginBottom:'24px' }}>
          {attive.map(v => (
            <div key={v.id} style={{ background:'var(--bg-card,#141414)', border:'1px solid var(--border)', borderRadius:'10px', padding:'14px 20px', display:'flex', alignItems:'center', gap:'14px' }}>
              <div style={{ width:'40px', height:'40px', background:'#8B5CF620', border:'1px solid #8B5CF630', borderRadius:'8px', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                <Star size={16} color="#8B5CF6"/>
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:'700', fontSize: 'var(--font-size-sm)' }}>{v.nome}</div>
                <div style={{ color:'var(--text-dim,#666)', fontSize: 'var(--font-size-xs)', marginTop:'2px' }}>
                  {v.descrizione || '—'}
                  {v.divisibile && <span style={{ marginLeft:'8px', color:'#8B5CF6', fontSize: 'var(--font-size-xs)', fontWeight:'700' }}>· DIVISIBILE</span>}
                </div>
              </div>
              <div style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-xl)', fontWeight:'800', color:'#8B5CF6', marginRight:'8px' }}>
                €{parseFloat(v.importo).toFixed(2)}
              </div>
              {puoModificare && <button style={s.btnIcon} onClick={() => openEdit(v)} title="Modifica"><Edit2 size={13}/></button>}
              {puoEliminare && <button style={{ ...s.btnIcon, background:'#FEE4E2', border:'1px solid #FCA5A5', color:'#EF4444' }} onClick={() => handleDelete(v)} title="Disattiva"><Trash2 size={13}/></button>}
            </div>
          ))}
          {attive.length === 0 && (
            <div style={{ textAlign:'center', color:'var(--text-dim,#666)', padding:'40px', background:'var(--bg-card,#141414)', borderRadius:'10px', border:'1px solid var(--border)' }}>
              Nessuna voce nel listino. Aggiungine una con "+ NUOVA VOCE".
            </div>
          )}
        </div>

        {/* Voci disattivate */}
        {disattive.length > 0 && (
          <>
            <div style={{ fontSize: 'var(--font-size-xs)', fontWeight:'700', letterSpacing:'2px', color:'var(--text-dim)', marginBottom:'8px' }}>DISATTIVATE</div>
            <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
              {disattive.map(v => (
                <div key={v.id} style={{ background:'var(--bg-card,#141414)', border:'1px solid var(--border)', borderRadius:'10px', padding:'10px 20px', display:'flex', alignItems:'center', gap:'14px', opacity:'0.5' }}>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:'600', fontSize: 'var(--font-size-sm)', color:'#666' }}>{v.nome}</div>
                  </div>
                  <div style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-lg)', fontWeight:'700', color:'#555' }}>€{parseFloat(v.importo).toFixed(2)}</div>
                  {puoModificare && <button style={{ ...s.btnIcon, color:'#22C55E' }} onClick={() => handleToggle(v)} title="Riattiva"><CheckCircle size={13}/></button>}
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Pannello form */}
      {showPanel && (
        <div style={{ width:'320px', flexShrink:0, background:'var(--bg,#0D0D0D)', border:'1px solid var(--border)', borderRadius:'12px', height:'fit-content', position:'sticky', top:'20px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 20px', borderBottom:'1px solid var(--border)' }}>
            <span style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-sm)', fontWeight:'700', letterSpacing:'2px' }}>
              {editing ? 'MODIFICA VOCE' : 'NUOVA VOCE'}
            </span>
            <button style={{ background:'transparent', border:'none', color:'#666', cursor:'pointer' }} onClick={() => setShowPanel(false)}><X size={16}/></button>
          </div>
          <form onSubmit={handleSubmit} style={{ padding:'20px', display:'flex', flexDirection:'column', gap:'12px' }}>
            <div>
              <label style={s.label}>NOME ATTIVITÀ *</label>
              <input style={s.inp} value={form.nome} onChange={e=>setForm(f=>({...f,nome:e.target.value}))} required placeholder="es. Club Series"/>
            </div>
            <div>
              <label style={s.label}>IMPORTO (€) *</label>
              <input style={s.inp} type="number" step="0.01" min="0" value={form.importo} onChange={e=>setForm(f=>({...f,importo:e.target.value}))} required placeholder="65.00"/>
            </div>
            <div>
              <label style={s.label}>DESCRIZIONE</label>
              <input style={s.inp} value={form.descrizione} onChange={e=>setForm(f=>({...f,descrizione:e.target.value}))} placeholder="Opzionale"/>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:'10px', padding:'10px 12px', background:'var(--bg-input,#1A1A1A)', borderRadius:'8px', border:'1px solid var(--border2)', cursor:'pointer' }}
              onClick={() => setForm(f=>({...f,divisibile:!f.divisibile}))}>
              <div style={{ width:'18px', height:'18px', borderRadius:'4px', border:`2px solid ${form.divisibile?'#8B5CF6':'var(--border2)'}`, background: form.divisibile?'#8B5CF6':'transparent', display:'flex', alignItems:'center', justifyContent:'center', transition:'all 0.15s' }}>
                {form.divisibile && <span style={{ color:'#fff', fontSize: 'var(--font-size-xs)', fontWeight:'900' }}>✓</span>}
              </div>
              <div>
                <div style={{ fontSize: 'var(--font-size-xs)', fontWeight:'700' }}>Compenso divisibile</div>
                <div style={{ fontSize: 'var(--font-size-xs)', color:'#666' }}>L'importo viene diviso per il numero di organizzatori</div>
              </div>
            </div>
            {editing && (
              <div style={{ display:'flex', alignItems:'center', gap:'10px', padding:'10px 12px', background:'var(--bg-input,#1A1A1A)', borderRadius:'8px', border:'1px solid var(--border2)', cursor:'pointer' }}
                onClick={() => setForm(f=>({...f,attivo:!f.attivo}))}>
                <div style={{ width:'18px', height:'18px', borderRadius:'4px', border:`2px solid ${form.attivo?'#22C55E':'var(--border2)'}`, background: form.attivo?'#22C55E':'transparent', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  {form.attivo && <span style={{ color:'#fff', fontSize: 'var(--font-size-xs)', fontWeight:'900' }}>✓</span>}
                </div>
                <div style={{ fontSize: 'var(--font-size-xs)', fontWeight:'700' }}>Voce attiva</div>
              </div>
            )}
            <div style={{ display:'flex', gap:'10px', marginTop:'8px' }}>
              <button type="button" style={s.btnSec} onClick={() => setShowPanel(false)}>ANNULLA</button>
              <button type="submit" style={{ ...s.btnPri, flex:1 }} disabled={saving}>
                {saving ? 'SALVO...' : editing ? 'AGGIORNA' : 'CREA'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

const s = {
  title:  { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  btnPri: { display:'flex', alignItems:'center', gap:'8px', background:'#8B5CF6', color:'#fff', border:'none', borderRadius:'8px', padding:'11px 18px', fontSize: 'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
  btnSec: { display:'flex', alignItems:'center', gap:'8px', background:'var(--bg-input,#1A1A1A)', color:'var(--text,#fff)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'9px 14px', fontSize: 'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
  btnIcon:{ background:'var(--bg-input,#1A1A1A)', border:'1px solid var(--border2)', borderRadius:'6px', padding:'7px 9px', color:'var(--text-muted,#999)', cursor:'pointer' },
  label:  { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'#555', display:'block', marginBottom:'4px' },
  inp:    { background:'var(--bg-input,#1A1A1A)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'8px 12px', color:'var(--text,#fff)', fontSize: 'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
};
